import { render, staticRenderFns } from "./AddBlockButton.vue?vue&type=template&id=32e2990e&"
import script from "./AddBlockButton.vue?vue&type=script&lang=js&"
export * from "./AddBlockButton.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddBlockButton.vue"
export default component.exports